import dataType from '../dataType';

const fcaRegulatedEntities = {
    name: 'FCARegulatedEntities',
    type: dataType.string
};

export default fcaRegulatedEntities;
